import {useMemo} from "react";
import {createMap} from "../../utils/utils";

export const useMap = <T>(array: T[], identifier: keyof T | string = "id") => {
  return useMemo(() => {
    return createMap(array, identifier)
  }, [array, identifier])
}
